/** See `src/i18n/locales/en/roles.ts`. */
export const roles = {
  form: {
    person: 'Persoon',
    choose: 'Kies…',
    grant: '{{label}} toekennen',
    revoke: '{{label}} intrekken',
    back: 'Terug',
  },
  company: {
    title: 'Bedrijfsbeheerders',
    lead: 'Een bedrijfsbeheerder beheert de eigen informatie, afdelingen, leden en provisionering van dit bedrijf. Toekennen en intrekken wordt geaudit.',
    label: 'bedrijfsbeheerder',
    rowsLabel: 'de bedrijfsleden',
  },
  department: {
    title: 'Afdelingsbeheerders (coach)',
    lead: 'Een afdelingsbeheerder leest de leden en aggregaten van deze afdeling, en — onder de regel voor individuele toegang — de individuele statistieken die de toestemmingsbasis dekt. Toekennen en intrekken wordt geaudit.',
    label: 'afdelingsbeheerder',
    rowsLabel: 'de afdelingsleden',
  },
  admins: {
    title: 'Platformbeheerders',
    lead: 'Een platformbeheerder heeft elke scoped bevoegdheid. Het doel van een aanstelling moet een login hebben en een primaire identiteit zijn; de laatste beheerder kan niet worden teruggetrokken.',
    name: 'Naam',
    email: 'E-mail',
    retire: 'Terugtrekken',
    rowsLabel: 'de beheerders',
    searchPeople: 'Personen zoeken',
    searchPlaceholder: 'Naam of e-mail',
    person: 'Persoon',
    choose: 'Kies…',
    noEligible: 'Geen geschikte persoon gevonden — ze hebben een eigen login nodig.',
    appoint: 'Aanstellen',
    usersLabel: 'de gebruikers van het platform',
  },
} as const;
